import Button from "@/Atoms/Input/Button";
import styles from './Modal.module.scss'

export type ModalProps = {
  onSubmit: (result: any) => Promise<any>
  onClose?: () => void
  isOpen?: boolean,
}
const Modal = (
  {
    title,
    children,
    onCancel,
    ...props
  }: {
  title: string,
  children: any,
  onCancel?: () => void
}) => {

  return <div className={styles.modal} {...props}>
    <div className={styles.dialog}>
      <h2>{title}</h2>
      <Button onClick={() => onCancel && onCancel()} className={styles.close}>
        <i className="fa-solid fa-xmark"></i>
      </Button>
      {children}
    </div>
  </div>

}


export default Modal;
